import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isEmpty, toPlainObject } from 'lodash';

import { EBON_BILLING_FORM_NAME } from '../../../constants/funnel';

import { lockEbons } from '../../../services/ebon/actions';
import { saveUserCoordinates } from '../../../services/account/myprofile/actions';

import { storeLastUserInfo } from '../../../utils/storageUtils';

import AddressForm from './AddressForm';

import './FunnelAddressStepStyle.scss';

const FunnelAddressStep = ({
    partnerId,
    setUserInfo,
    merchantCardPath,
    i18n,
    ebon,
    form,
    lockEbons,
    saveUserCoordinates,
    lockFailure,
    user
}) => {
    const [cappingError, setCappingError] = useState(false);

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    const FORM_NAME = EBON_BILLING_FORM_NAME;

    // Do lock
    const handleSubmit = async () => {
        const formData = form[FORM_NAME].values;

        let number = formData.phoneNumber;
        if (!number.startsWith('+')) {
            number = `+33${number.startsWith('0') ? number.substring(1, number.length) : number}`;
        }

        const tempUserInfo = {
            lastname: formData.lastname,
            firstname: formData.firstname,
            billingAdressLine1: formData.address,
            billingAdressLine2: formData.address,
            billingAdress: formData.address,
            billingCity: formData.city,
            billingPostalCode: formData.zipcode,
            billingCountry: formData.country,
            phoneNumber: number,
            saveAddress: formData.saveAddress
        };

        const ebonCart = {
            lockRequests: ebon.cart,
            userId: user.username,
            partnerId: partnerId,
            fixedFacialValue: !hasFreeFacial
        };

        storeLastUserInfo(formData.firstname, formData.lastname, number);
        setUserInfo(tempUserInfo);

        if (formData.saveAddress) {
            saveUserCoordinates({
                civility: formData.civility,
                lastname: formData.lastname,
                firstname: formData.firstname,
                address: formData.address,
                postcode: formData.zipcode,
                city: formData.city,
                country: formData.country,
                phoneNumber: number
            });
        }

        lockEbons(ebonCart, number);
    };

    // Handle lock failure
    useEffect(() => {
        if (!isEmpty(lockFailure)) {
            // Check user capping
            if (lockFailure.statusCode === 406) {
                setCappingError(true);
            }
        }
    }, [lockFailure]);

    return (
        <div id="funnel-address-container">
            <h3>{i18n.BILLING_ADDRESS}</h3>
            <AddressForm
                formName={FORM_NAME}
                cappingError={cappingError}
                handleSubmit={handleSubmit}
                merchantCardPath={merchantCardPath}
            />
        </div>
    );
};

FunnelAddressStep.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    setUserInfo: PropTypes.func,
    merchantCardPath: PropTypes.string
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.page.EBON,
        ebon: state.ebon,
        form: state.form,
        lock: state.ebon.lock,
        lockFailure: state.ebon.lockFailure,
        user: user
    };
};

const mapDispatchToProps = {
    lockEbons,
    saveUserCoordinates
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FunnelAddressStep));



// WEBPACK FOOTER //
// ./src/components/funnel/address-step/FunnelAddressStep.js